import { render, staticRenderFns } from "./Postpaid.vue?vue&type=template&id=017466b5"
import script from "./Postpaid.vue?vue&type=script&lang=js"
export * from "./Postpaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports